import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown, Menu, X } from 'lucide-react';

const Header = () => {
  const [loginDropdownOpen, setLoginDropdownOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="bg-white/95 backdrop-blur-sm border-b border-[#E2E8F0] sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between">
        <a href="https://entrepreneurladyhustler.com/en/" className="flex items-center gap-3 flex-shrink-0" data-testid="header-logo">
          <span className="font-heading text-lg sm:text-xl text-[#2C2C2C]">The Lady Hustler Society Club</span>
        </a>
        
        {/* Mobile menu button */}
        <button 
          className="md:hidden p-2 text-[#2C2C2C]"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          data-testid="mobile-menu-button"
        >
          {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
        
        <nav className="hidden md:flex items-center gap-8">
          <a 
            href="https://entrepreneurladyhustler.com/en/blog/"
            className="font-label text-xs text-[#767C91] tracking-widest hover:text-[#9D6E6D] transition-colors"
            data-testid="nav-blog"
          >
            THE JOURNAL
          </a>
          <a 
            href="https://join.entrepreneurladyhustler.com"
            target="_blank"
            rel="noopener noreferrer"
            className="font-label text-xs text-[#767C91] tracking-widest hover:text-[#9D6E6D] transition-colors"
            data-testid="nav-membership"
          >
            MEMBERSHIP
          </a>
          <a 
            href="https://societe.entrepreneurladyhustler.com"
            target="_blank"
            rel="noopener noreferrer"
            className="font-label text-xs text-[#767C91] tracking-widest hover:text-[#9D6E6D] transition-colors"
            data-testid="nav-societe"
          >
            THE SOCIÉTÉ
          </a>
          <a 
            href="https://entrepreneurladyhustler.com/en/get-involved-the-lady-hustler-society-club/"
            target="_blank"
            rel="noopener noreferrer"
            className="font-label text-xs text-[#767C91] tracking-widest hover:text-[#9D6E6D] transition-colors"
            data-testid="nav-campaign"
          >
            GET INVOLVED
          </a>
          
          {/* Member Login Dropdown */}
          <div className="relative">
            <button 
              onClick={() => setLoginDropdownOpen(!loginDropdownOpen)}
              onBlur={() => setTimeout(() => setLoginDropdownOpen(false), 150)}
              className="font-label text-xs text-[#767C91] tracking-widest hover:text-[#9D6E6D] transition-colors flex items-center gap-1"
              data-testid="nav-login-dropdown"
            >
              MEMBER LOGIN
              <ChevronDown className="w-3 h-3" />
            </button>
            
            {loginDropdownOpen && (
              <div className="absolute top-full right-0 mt-2 bg-white border border-[#E2E8F0] shadow-lg py-2 min-w-[200px] z-50">
                <a 
                  href="https://app.entrepreneurladyhustler.com/login"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block px-4 py-2 font-label text-xs text-[#767C91] tracking-widest hover:bg-[#F2E1E1] hover:text-[#9D6E6D] transition-colors"
                  data-testid="nav-member-login"
                >
                  MEMBERSHIP LOGIN
                </a>
                <a 
                  href="https://theladyhustlersocietyclub.app.clientclub.net/login"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block px-4 py-2 font-label text-xs text-[#767C91] tracking-widest hover:bg-[#F2E1E1] hover:text-[#9D6E6D] transition-colors"
                  data-testid="nav-societe-login"
                >
                  THE SOCIÉTÉ LOGIN
                </a>
              </div>
            )}
          </div>
        </nav>

        <div className="flex items-center gap-4">
          <a 
            href="https://join.entrepreneurladyhustler.com"
            target="_blank"
            rel="noopener noreferrer"
            className="hidden sm:block cta-button py-2 px-4"
            data-testid="header-cta"
          >
            JOIN NOW
          </a>
        </div>
      </div>
      
      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-[#E2E8F0] px-4 py-4" data-testid="mobile-menu">
          <nav className="flex flex-col gap-4">
            <a 
              href="https://entrepreneurladyhustler.com/en/blog/"
              className="font-label text-sm text-[#767C91] tracking-widest hover:text-[#9D6E6D] transition-colors py-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              THE JOURNAL
            </a>
            <a 
              href="https://join.entrepreneurladyhustler.com"
              target="_blank"
              rel="noopener noreferrer"
              className="font-label text-sm text-[#767C91] tracking-widest hover:text-[#9D6E6D] transition-colors py-2"
            >
              MEMBERSHIP
            </a>
            <a 
              href="https://societe.entrepreneurladyhustler.com"
              target="_blank"
              rel="noopener noreferrer"
              className="font-label text-sm text-[#767C91] tracking-widest hover:text-[#9D6E6D] transition-colors py-2"
            >
              THE SOCIÉTÉ
            </a>
            <a 
              href="https://entrepreneurladyhustler.com/en/get-involved-the-lady-hustler-society-club/"
              target="_blank"
              rel="noopener noreferrer"
              className="font-label text-sm text-[#767C91] tracking-widest hover:text-[#9D6E6D] transition-colors py-2"
            >
              GET INVOLVED
            </a>
            
            {/* Mobile Login Links */}
            <div className="border-t border-[#E2E8F0] pt-4 mt-2">
              <p className="font-label text-xs text-[#9D6E6D] tracking-widest mb-3">MEMBER LOGIN</p>
              <a 
                href="https://app.entrepreneurladyhustler.com/login"
                target="_blank"
                rel="noopener noreferrer"
                className="block font-label text-sm text-[#767C91] tracking-widest hover:text-[#9D6E6D] transition-colors py-2"
              >
                Membership Login
              </a>
              <a 
                href="https://theladyhustlersocietyclub.app.clientclub.net/login"
                target="_blank"
                rel="noopener noreferrer"
                className="block font-label text-sm text-[#767C91] tracking-widest hover:text-[#9D6E6D] transition-colors py-2"
              >
                The Société Login
              </a>
            </div>
            
            {/* Mobile CTA */}
            <a 
              href="https://join.entrepreneurladyhustler.com"
              target="_blank"
              rel="noopener noreferrer"
              className="cta-button text-center py-3 mt-2"
            >
              JOIN NOW
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
